module.exports = __webpack_public_path__ + "static/symf.342314a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/symf.jpg
// module id = 182
// module chunks = 19817326959855 213628377533538